/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AssetProtocolDeleteAssetRequest,
  AssetProtocolGetAllAssetListResponse,
  AssetProtocolGetAssetImagesResponse,
  AssetProtocolGetAssetListRequest,
  AssetProtocolGetAssetListResponse,
  AssetProtocolGetAssetRequest,
  AssetProtocolGetAssetResponse,
  AssetProtocolUpdateAssetRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Asset<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Asset
   * @name GetAssetCreate
   * @request POST:/asset/get_asset
   */
  getAssetCreate = (data: AssetProtocolGetAssetRequest, params: RequestParams = {}) =>
    this.http.request<AssetProtocolGetAssetResponse, any>({
      path: `/asset/get_asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Asset
   * @name DeleteAssetCreate
   * @request POST:/asset/delete_asset
   */
  deleteAssetCreate = (data: AssetProtocolDeleteAssetRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/asset/delete_asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Asset
   * @name UpdateAssetCreate
   * @request POST:/asset/update_asset
   */
  updateAssetCreate = (data: AssetProtocolUpdateAssetRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/asset/update_asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Asset
   * @name GetAssetListCreate
   * @request POST:/asset/get_asset_list
   */
  getAssetListCreate = (data: AssetProtocolGetAssetListRequest, params: RequestParams = {}) =>
    this.http.request<AssetProtocolGetAssetListResponse, any>({
      path: `/asset/get_asset_list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Asset
   * @name GetAllAssetListList
   * @request GET:/asset/get_all_asset_list
   */
  getAllAssetListList = (params: RequestParams = {}) =>
    this.http.request<AssetProtocolGetAllAssetListResponse, any>({
      path: `/asset/get_all_asset_list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Asset
   * @name GetAssetImagesList
   * @request GET:/asset/get_asset_images
   */
  getAssetImagesList = (params: RequestParams = {}) =>
    this.http.request<AssetProtocolGetAssetImagesResponse, any>({
      path: `/asset/get_asset_images`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
